import { IWordListItem } from 'components/Vote/ActiveVote/VoteWordCloud/WordCloud';

export const PreviewWordList: IWordListItem[] = [
	{ count: 10, text: 'previewWordDiscussion' },
	{ count: 19, text: 'previewWordPlatform' },
	{ count: 8, text: 'previewWordStatement' },
	{ count: 17, text: 'previewWordKnowledge' },
	{ count: 12, text: 'previewWordSmartphone' }
];
